import React, { useContext } from "react"
import { CursorContext } from '../../../context/cursorContext'

import './landingtext.scss'

const LandingText = ({ content, size, textBackgroundColor}) => {
    const { cursorConfig, setCursor } = useContext(CursorContext);

    return (
        <div 
            className={"landingtext hero "}
            onMouseEnter={() => setCursor({ 
                ...cursorConfig, 
                shape: "default", 
                rotation: "-30",
                scale: '1', 
                color: "var(--darkgrey)" 
            })}
            style={textBackgroundColor?.presets === 'custom' ? { backgroundColor: textBackgroundColor?.custom } : textBackgroundColor?.presets === 'var(--gradient)' ? { backgroundImage: textBackgroundColor?.presets } : { backgroundColor: textBackgroundColor?.presets }}
        >
            <div
                className="content"
                dangerouslySetInnerHTML={{ __html: content }}
            />
        </div>
    )
}

export default LandingText
